import { render } from "./TermsOfService.vue?vue&type=template&id=1791ac12&scoped=true&ts=true"
import script from "./TermsOfService.vue?vue&type=script&lang=ts"
export * from "./TermsOfService.vue?vue&type=script&lang=ts"

import "./TermsOfService.vue?vue&type=style&index=0&id=1791ac12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1791ac12"]])

export default __exports__